// extracted by mini-css-extract-plugin
module.exports = {"background":"MenuBackground--background--3cmM2","background_logo":"MenuBackground--background_logo--1kP17"};